import moment from 'moment';

// metric.end_date is a formatted m/d/Y string; use metricEndDate_unix (UTC seconds).
// A KR ending today still has "0 days left".
export const getDaysLeftText = (
  t: (key: string) => string,
  metric: {
    end_date?: number | string; metricEndDate_unix?: number | string; metricDaysLeft?: number;
  } | undefined,
  goal?: { target_date?: number | string },
): string => {
  const end = metric?.metricEndDate_unix || goal?.target_date;
  const endMoment = end ? moment.unix(Number(end)).utc() : null;
  if (endMoment?.isBefore(moment.utc(), 'day')) {
    return `${t('Ended')} ${endMoment.format('MMM D, YYYY')}`;
  }
  return `${metric?.metricDaysLeft} ${t('days left')}`;
};
